/*
 * Main Section 사용하는 상수
 * */

export const CONTENT_NAME = {
  LIVE: 'LIVE',
  VOD: 'VOD',
  CATCH: 'CATCH',
  STORY: 'STORY',
  CATEGORY: 'CATEGORY',
  BANNER: 'BANNER',
  MAIN_LIST_BANNER: 'MAIN_LIST_BNR',
  CINETY: 'CINETY',
  PREVIEW: 'PREVIEW',
};

export const TEMPLATE_NAME = {
  DEFAULT: 'defaultTemplate',
};
